import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

import { GenericStatusEnum, ThirdPartyTypeEnum } from '@e-socna/data-layer';

import { SpeedDial } from '../../../components/SpeedDial';
import { ThirdParties } from '../../../components/ThirdParties';
import {
  PATH_EXTERNAL_PEOPLE_NEW,
  PATH_INTERNAL_PEOPLE_NEW,
} from '../../../app/constants/paths.constant';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

interface Props {
  readonly isInternal: boolean;
}

export const PeopleTabPanel = ({ isInternal }: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  const speedDialActions = [
    isInternal
      ? {
          id: 'createInternalPerson',
          icon: <PersonAddAltIcon />,
          name: 'Créer Personne SOCNA',
          to: PATH_INTERNAL_PEOPLE_NEW,
        }
      : {
          id: 'createExternalPerson',
          icon: <PersonAddAltIcon />,
          name: 'Créer Personne',
          to: PATH_EXTERNAL_PEOPLE_NEW,
        },
  ];

  return (
    <>
      <ThirdParties
        initialGridState={initialGridState}
        isInternal={isInternal}
        kind={ThirdPartyTypeEnum.Person}
        status={GenericStatusEnum.Enabled}
      />
      <SpeedDial
        actions={speedDialActions}
        title="Actions possibles sur les Personnes"
      />
    </>
  );
};
